import { registerModuleUsage } from "../../../utils/useModuleAccess"
import React, { useState, useEffect, useContext, useMemo, useRef } from 'react'
import { useHistory, useLocation } from "react-router-dom"

import { Box, Tabs, Tab, Badge, Tooltip, Divider, IconButton, Paper, Popper, ClickAwayListener, TextField, Typography } from '@mui/material'

import { QueueSocket } from '../../../routes'
import QueueContainer from '../../ManageCalls/QueueContainer'
import api from '../../../api'

import QueueIcon from '@mui/icons-material/Group';
import OngoingIcon from '@mui/icons-material/SupportAgent';
import ReactivationIcon from '@mui/icons-material/Update';
import FinishedIcon from '@mui/icons-material/Done';
import RefreshIcon from '@mui/icons-material/Refresh';
import SettingsIcon from '@mui/icons-material/Settings';
import ServiceFilterComponent from '../ServiceFilterComponent'
import FinishedFilter from './FinishedFilter'
import SortComponent from "../../ManageCalls/SortComponent";
import ToogleJustMe from '../../ManageCalls/JustMe'
import { getSession } from '../../../auth'
import useNotification from '../../Notification'
import Loading from '../../Loading'
import { setFaviconBadge } from '../../../utils/favicon'

import * as workerInterval from 'worker-interval';
import FinishedQueueContainer from '../../ManageCalls/FinishedQueueContainer'

let running = false


const subsObj = (objOld, objNew) => {
    const parsed = {}
    objOld.map(each => { parsed[each.id] = each })
    const newobj = {}
    if (Array.isArray(objNew)) {
        objNew.map(each => { newobj[each.id] = each })
        return Object.values({ ...parsed, ...newobj })
    }
    newobj[objNew.id] = objNew
    return Object.values({ ...parsed, ...newobj })
}

const SwitchHover = ({ active, normal, hovering }) => {
    const [hover, setHover] = useState(false)


    return (
        <Box onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
            {!hover || !active ?
                <>
                    {normal}
                </>
                :
                <>
                    {hovering}
                </>
            }
        </Box>
    )
}

const TabPanel = (props) => {
    const { children, value, index, sub } = props;
    const tabActive = value == index;
    const tabType = sub ? 'sub-tab-active' : 'tab-active';
    const displayMode = tabActive ? 'block' : 'none'
    return (
        <div className={tabActive ? tabType : null} style={{ display: displayMode }}>
            {
                children
            }
        </div>
    );
}

let notificated = false
var timeout = 0

const allChatsInitialState = {
    queueState: [],
    queueAmount: 0,
    onchatState: [],
    onchatAmount: 0,
    reactivatedState: [],
    reactivatedAmount: 0,
    finishedState: [],
    finishedAmount: 0,
    notificationState: [],
    notificationAmount: 0,
}

const NewConversationList = (props) => {
    const history = useHistory()
    const location = useLocation()

    const { visible, chatState, sendNotification, notifications, setNotifications } = useContext(QueueSocket)

    const user = getSession();
    const settings = user.profile.enterprise.settings
    const finished_infinite_scroll = user.profile.enterprise.finished_infinite_scroll
    const limit = 6
    const loading = props.loading
    const [newQueue, setNewQueue] = useState(0)
    const [unreadMessages, setUnreadMessages] = useState(0)
    const [refresh, setRefresh] = useState(false)
    const [filterSettings, setFilterSettings] = useState()
    const [outLoading, setOutLoading] = useState(false)

    const [queueAdded, setQueueAdded] = useState(false)
    const [onchatAdded, setOnchatAdded] = useState(false)
    const [reactivatedAdded, setReactivatedAdded] = useState(false)
    const [finishedAdded, setFinishedAdded] = useState(false)
    const [notificationAdded, setNotificationAdded] = useState(false)
    const [heartbeat, setHeartbeat] = useState(false)
    const [initHeartbeat, setInitHeartbeat] = useState(false)

    const [onChatAddedMessages, setOnChatAddedMessages] = useState(0)
    const [onQueueAddedMessages, setOnQueueAddedMessages] = useState(0)

    const [orderBy, setOrderBy] = useState("-id");
    const [justMe, setJustMe] = useState(true)

    const [ classificationFilter, setClassificationFilter ] = useState(null)
    const [ selectedChats, setSelectedChats ] = useState([])
    const [ progressBarMax, setProgressBarMax ] = useState(() => localStorage.getItem("progress-bar-max-chat") ?? 30)
    const [ settingsAnchorEl, setSettingsAnchorEl ] = useState(null)
    const hadFilterSettingsRef = useRef(false)

    const tabNames = ['queue', 'onchat', 'reactivated', 'finished']

    useEffect(() => {
        localStorage.setItem("progress-bar-max-chat", progressBarMax)
    }, [progressBarMax])

    const reloadState = () => {
        setRefresh(p => !p)
    }

    const getFilterDataForQueue = (where) => {
        if (!filterSettings?.data)
            return ''

        if (filterSettings.serviceSearch && where !== 'onchat')
            return filterSettings.dataWithoutServiceSearch || ''

        return filterSettings.data
    }

    const triggerQueueRefresh = (where) => {
        switch (where) {
            case 'queue':
                setQueueAdded(p => !p)
                break
            case 'onchat':
                setOnchatAdded(p => !p)
                break
            case 'reactivated':
                setReactivatedAdded(p => !p)
                break
            case 'notification':
                setNotificationAdded(p => !p)
                break
            case 'finished':
                setFinishedAdded(p => !p)
                break
            default:
                break
        }
    }

    const resetAllChats = () => {
        allChats.queueState = []
        allChats.queueAmount = 0
        allChats.onchatState = []
        allChats.onchatAmount = 0
        allChats.reactivatedState = []
        allChats.reactivatedAmount = 0
        allChats.finishedState = []
        allChats.finishedAmount = 0
        allChats.notificationState = []
        allChats.notificationAmount = 0
    }

    const [allChats, setAllChats] = useState(
        allChatsInitialState
    )

    useEffect(async () => {
        const hadFilterSettings = hadFilterSettingsRef.current
        hadFilterSettingsRef.current = Boolean(filterSettings?.data)

        if (!filterSettings || filterSettings.data == '') {
            if (!hadFilterSettings)
                return

            resetAllChats()

            let where = tabNames[props.activeTab]
            if (props.activeTab === 2 && props.activeSubTab === 1)
                where = 'notification'

            await getData(where)
            triggerQueueRefresh(where)
            props.refresh()
            return
        }

        resetAllChats()

        const promises = []
        promises.push(getData('queue'))
        promises.push(getData('onchat'))
        promises.push(getData('reactivated'))
        if (!finished_infinite_scroll)
            promises.push(getData('finished'))
        await Promise.all(promises)

        triggerQueueRefresh('queue')
        triggerQueueRefresh('onchat')
        triggerQueueRefresh('reactivated')
        if (!finished_infinite_scroll)
            triggerQueueRefresh('finished')
        triggerQueueRefresh('notification')
        props.refresh()

    }, [filterSettings])


    const countData = async () => {

        let url = 'api/enterprises/' + props.enterpriseId + `/calls/chat/count/?filtered=True`

        if (filterSettings?.data)
            url = url.concat(filterSettings.serviceSearch ? (filterSettings.dataWithoutServiceSearch || '') : filterSettings.data)

        const res = await api.get(url)

        if (res.status == 200)
            return res.data
        else {
            if (filterSettings){
                setFilterSettings(null)
                useNotification(
                    'Informação',
                    `Seus filtros foram desabilitados para melhorar o tempo de resposta.`,
                    'info'
                )
            }
        }

        return false
    }

    useEffect(() => {

        if (settings.websockets)
            return

        setTimeout(() => {
            workerInterval.setInterval(() => setHeartbeat(p => !p), 5000)
        }, 1000)
        setInitHeartbeat(true)

        window.updateNotify = () => {
            setNotificationAdded(p => !p)
        }
    }, [])


    useEffect(async () => {

        if (running === true)
            return

        if (initHeartbeat) {

            running = true

            const notificate = { queues: 0, messages: 0, chats: 0 }

            if (props.activeChat?.lh_chat_id) {
                const urlParams = new URLSearchParams(window.location.search)
                if (window.location.pathname === '/chat' && urlParams.get('selectedTab') === 'service') {
                    api.get(`api/enterprises/${props.enterpriseId}/calls/chat/set_read/${props.activeChat.lh_chat_id}/`, { timeout: 0 }).catch(() => {})
                }
            }

            const data = await countData()
            if (!data) {
                running = false
                return;
            }

            const new_queued = data.queued
            const new_queued_messages = data.unreadqueuedmessages
            const new_onchat = data.onchat
            const new_onchat_messages = data.unreadonchatmessages
            const new_reactivated = data.reactivated
            const new_finished = data.finished

            let renownqueue = 0

            if (new_queued != allChats['queueAmount']) {
                notificate.queues = new_queued - allChats['queueAmount']
                renownqueue = 1
            }

            if (new_queued_messages != onQueueAddedMessages) {
                renownqueue = 1
                if (new_queued_messages > onQueueAddedMessages)
                    notificate.messages = new_queued_messages - onQueueAddedMessages
            }

            let renewonchat = 0

            if (onChatAddedMessages != new_onchat_messages) {

                if (new_onchat_messages > onChatAddedMessages)
                    notificate.messages += new_onchat_messages - onChatAddedMessages

                renewonchat = 1

                setOnChatAddedMessages(new_onchat_messages)

                if (props.activeChat && props.activeChat.lh_chat_id) {
                    //dont need to wait
                    api.get(`api/enterprises/${props.enterpriseId}/calls/chat/set_read/${props.activeChat.lh_chat_id}/`, { timeout: 0 })
                }
            }

            if (renownqueue === 1) {
                setOnQueueAddedMessages(new_queued_messages)
                setQueueAdded(p => !p)
            }

            if (!filterSettings?.serviceSearch && new_onchat !== allChats['onchatAmount'])
                renewonchat = 1

            if (renewonchat) {
                setOnchatAdded(p => !p)
            }

            if (new_reactivated != allChats['reactivatedAmount']) {
                //allChats['reactivatedState'] = []
                setReactivatedAdded(p => !p)
            }

            if (!finished_infinite_scroll && new_finished != allChats['finishedAmount']) {

                if (!filterSettings) {
                    setFinishedAdded(p => !p)
                }

            }

            if (finished_infinite_scroll) {
                allChats['finishedAmount'] = new_finished
            }

            let type = notificate.queues > 0 ? 'newChat' : 'newMessage'

            type = notificate.messages > 0 ? type : null

            const place = []
            if (renownqueue === 1)
                place.push('em fila')
            if (renewonchat)
                place.push('em atendimento')

            if (type) {
                const urlParams = new URLSearchParams(window.location.search)
                const isChatServicePageOpen = window.location.pathname === '/chat' && urlParams.get('selectedTab') === 'service' && props.activeChat?.lh_chat_id
                if (!isChatServicePageOpen) {
                    // deprecated !
                    // sendNotification(type, type === 'newChat' ?
                    //     notificate.queues : notificate.chats, notificate.messages, place.join(' e '));
                    setNotifications(true)
                }
            }

        }

        running = false
    }, [heartbeat, props.updateList])



    const getData = async (where, offset = 0, channel = 0, newOrder = null) => {
        const ob = newOrder ? newOrder : orderBy;
        let url = ''
        if (where == 'notification' && justMe) {
            url =
                "api/enterprises/" +
                props.enterpriseId +
                `/calls/chat/${where}/?limit=${limit}&offset=${offset}&filtered=true&orderBy=${ob}&justme=true`;
        } else {
            url =
                "api/enterprises/" +
                props.enterpriseId +
                `/calls/chat/${where}/?limit=${limit}&offset=${offset}&filtered=true&orderBy=${ob}`;
        }


        if (channel != 0)
            url = url.concat(`&channel=${channel}`)

        const filterData = getFilterDataForQueue(where)
        if (filterData)
            url = url.concat(filterData)

        const res = await api.get(url, { timeout: 5000 })
        if (res.status == 200) {

            let results = res.data.results

            //case we are receiving something on websocket
            if (channel != 0)
                return results

            //Add indexes from offset to chats
            const result_new_positions = results.map((chat, index) => {
                chat.position = offset + index;
                results[index] = { ...chat, ...chat.lhc }
                return chat.position
            })

            allChats[`${where}State`] = allChats[`${where}State`].filter(chat => !result_new_positions.includes(chat.position))

            let newChats = subsObj(allChats[`${where}State`], results)

            const newState = {}
            newState[`${where}State`] = newChats
            newState[`${where}Amount`] = res.data.count

            setAllChats(prevState => ({ ...prevState, ...newState }))

            return true
        } else {
            if (filterSettings){
                setFilterSettings(null)
                useNotification(
                    'Informação',
                    `Seus filtros foram desabilitados para melhorar o tempo de resposta.`,
                    'info'
                )
            }
        }

        return false
    }

    const updateData = async (newOrder = null) => {
        if (newOrder !== undefined) {
            setOrderBy(newOrder);
        }
        setOutLoading(true);

        Object.assign(allChats, allChatsInitialState)

        const where = tabNames[props.activeTab];
        const ret = await getData(where, 0, 0, newOrder);
        if (ret === true) {
            switch (where) {
                case 'queue':
                    setQueueAdded(p => !p);
                    break;
                case 'onchat':
                    setOnchatAdded(p => !p);
                    break;
                case 'reactivated':
                    setReactivatedAdded(p => !p);
                    break;
                case 'notification':
                    setNotificationAdded(p => !p);
                    break;
                case 'finished':

                    setFinishedAdded(p => !p);
                    break;
            }
            props.refresh();
            props.refreshChat();
            reloadState();
        }
        setOutLoading(false);
        return ret;
    };

    const updatejustme = async (justme) => {
        allChats['notificationState'] = []
        allChats['notificationAmount'] = 0
        setNotificationAdded(p => !p);
        setJustMe(justme)
    }

    const addChat = (newchat, where) => {
        if (!newchat || newchat.length == 0)
            return
        const chat = newchat[0]


        allChats[`${where}State`].map(each => { each.position += 1 })
        allChats[`${where}Amount`] += 1
        chat.position = 0
        allChats[`${where}State`] = subsObj(allChats[`${where}State`], chat)


        switch (where) {
            case 'queue':
                setQueueAdded(p => !p)
                break
            case 'onchat':
                setOnchatAdded(p => !p)
                break
            case 'reactivated':
                setReactivatedAdded(p => !p)
                break
            case 'finished':
                setFinishedAdded(p => !p)
                break
            default:
                break
        }
    }

    //always return the removed chat, so we can disable it if it's the same as activeChat if we are not the agent.
    const removeChat = (parameter, where) => {
        let flag = 'channel'

        if (where == 'reactivated')
            flag = 'callerid'

        const foundChat = allChats[`${where}State`].find(oldChat => oldChat[flag] == parameter)

        if (!foundChat)
            return
        allChats[`${where}State`].map(each => {
            if (foundChat.position < each.position)
                each.position -= 1
        })
        allChats[`${where}State`] = allChats[`${where}State`].filter(oldChat => oldChat[flag] != parameter)
        allChats[`${where}Amount`] -= 1

        return foundChat
    }
    const notificateUserQueue = () => {
        const queues = allChats['queueState'].map(each => each.messages.filter(msg => !msg.is_read).length).reduce((a, b) => a + b, 0)
        if (!notificated) {
            // deprecated !
            // sendNotification('newMessage', allChats[`queueAmount`], queues > 0 ? queues : 1);
            notificated = true
        }
        setNewQueue(queues > 0 ? queues : 1)
    }

    //Let's Count unreadMessages
    useEffect(() => {
        const onChats = allChats['onchatState'].map(each => each.unread_messages).reduce((a, b) => a + b, 0)
        setUnreadMessages(onChats)
    }, [allChats, refresh])

    // deprecated !
    // useEffect(() => {
    //     const hasUnread = unreadMessages > 0 || newQueue > 0
    //     setFaviconBadge('message', hasUnread)
    // }, [unreadMessages, newQueue])
    
    //Unread chats only on init and on refresh.
    useEffect(() => {
        if (props.activeTab == 0)
            allChats['queueState'].map(queue => queue.seen = true)
        const queues = (allChats['queueState'].filter(queue => !queue.seen)).length
        setNewQueue(queues)
    }, [refresh, allChats, props.activeTab])

    //If new chat, we should add it to the respective list accordingly
    const webSocketGetChats = async () => {
        if (chatState && chatState.new) {
            chatState.new = false
            const message = chatState.message
            const channel = chatState.channel
            let newchat = {}
            let removedChat = {}

            switch (message) {
                //Add chat on queue and offset actualchats

                case 'NEW_CHAT':
                    newchat = await getData('queue', 0, channel)
                    addChat(newchat, 'queue')
                    notificateUserQueue()
                    break;
                // Here I sent the chat directly on the message, maybe we should do it like this instead of sending and requesting channels?
                case 'DROP_CHAT':
                    removedChat = removeChat(channel.channel, 'onchat')
                    if (removedChat?.uniqueid == props.activeChat?.uniqueid) {
                        props.setActiveChat({})
                        useNotification(
                            'Informação',
                            `Seu chat foi transferido por ${channel.user}.`,
                            'info'
                        );
                    }
                    reloadState()

                    return
                //Remove chat from queue/reactivated and add onchat, deoffset queue, offset onchat
                case 'ONCHAT':
                    newchat = await getData('onchat', 0, channel)
                    removedChat = removeChat(channel, 'queue')
                    removeChat(newchat[0]?.callerid, 'reactivated') // this case is always per operator.
                    addChat(newchat, 'onchat')
                    if (props.activeChat && newchat.length > 0 && props.activeChat?.channel == newchat[0]?.channel)
                        props.activeChat.agent.name = newchat[0].agent.name
                    break;
                //Here we are receiving a new message on queue or ONCHAT from the client or agent
                //We should get this message on channel and update our chat accordingly, because it already exists
                //But we will only do it for ONCHAT messages, otherwise we will ignore it.
                //We will not do it if we are currently on this chat to avoid doublegetting
                case 'NEW_MESSAGE':
                    const oldchat = allChats['onchatState'].find(chat => chat.channel == channel)
                    if (oldchat && props.activeChat && oldchat.uniqueid != props.activeChat.uniqueid) {
                        const newmsg = await getData('onchat', 0, channel)
                        if (newmsg && newmsg.length > 0) {
                            oldchat.messages = newmsg[0].messages
                            props.refresh()
                            reloadState()
                        }
                    }
                    reloadState()
                    return;
                //Add chat on reactivated and offsetchat
                case 'REACTIVATE':
                    newchat = await getData('reactivated', 0, channel)
                    addChat(newchat, 'reactivated')
                    break;
                //Add chat on finished and offset actualchats
                case 'HANGUP':
                    newchat = await getData('finished', 0, channel)
                    removedChat = removeChat(channel, 'onchat')
                    if (removedChat)
                        addChat(newchat, 'finished')
                    break;
                // Will just reload everything here
                case 'NOTIFICATIONS':
                    if (channel) {
                        allChats[`notificationState`] = allChats[`notificationState`].filter(oldChat => oldChat.id != channel)
                        props.setActiveChat({})
                    }
                    setNotificationAdded(p => !p)
                    await getData('notification', 0)

                    break
                default:
                    break;
            }
            reloadState()

            //drop chat if we are not the one moving it.
            if (newchat[0]?.agents_id != user.profile.agent_id && removedChat?.uniqueid == props.activeChat.uniqueid) {
                props.setActiveChat({})

                if (message == 'ONCHAT')
                    useNotification(
                        'Informação',
                        `O chat foi atendido.`,
                        'info'
                    );
                else if (newchat[0] && !newchat[0].chatstatus && newchat[0].agent_name && removedChat && removedChat?.uniqueid == props.activeChat.uniqueid) {
                    useNotification(
                        'Informação',
                        `O chat foi finalizado por ${newchat[0].agent_name}.`,
                        'info'
                    );
                }
            }
        }
    }
    useEffect(() => {
        webSocketGetChats()
    }, [chatState])

    const itemCtrlClicked = async (chat) => {
        setSelectedChats((prev) => {
            const exists = prev.some((c) => c.id === chat.id)
            if (exists) 
                return prev.filter((c) => c.id !== chat.id)
            return [...prev, chat]
        })
    }

    const itemClicked = async (chat) => {
        registerModuleUsage("attendance")
        let where = tabNames[props.activeTab]
        props.closeProfile();
        props.setActiveChat(chat);

        if (props.activeSubTab === 1 && props.activeTab === 2) where = 'notification'
        if (props.activeTab !== 2 || props.activeSubTab !== 0) {
            setOutLoading(true)
            const newchat = await getData(where, 0, chat.channel ? chat.channel : chat.hash)
            setOutLoading(false)
            if (newchat && newchat.length > 0) {
                chat.messages = newchat[0].messages
                if ('last_user_msg_time' in newchat[0]) {
                    chat.last_user_msg_time = newchat[0].last_user_msg_time
                }
            }
            chat.unread_messages = 0
            if (chat.is_marked_unread) {
                chat.is_marked_unread = false
                api.post(`api/enterprises/${props.enterpriseId}/calls/chat/unmark_unread/`, { channel: chat.channel })
            }
            props.refresh()
            props.refreshChat()
            reloadState()
        }
    }

    const setActiveTab = (event, tab) => {

        props.closeProfile();
        props.setActiveChat({});
        props.setActiveTab(tab);
        if (tab == 0)
            notificated = false
    }

    const updateChatMessagePreview = (latestMessage) => {
        if (!latestMessage?.channel || !latestMessage?.message)
            return

        const stateKeys = ['queueState', 'onchatState', 'reactivatedState', 'notificationState']
        const newState = {}
        let changed = false

        stateKeys.forEach((stateKey) => {
            const chats = allChats[stateKey]
            if (!Array.isArray(chats))
                return

            const nextChats = chats.map((chat) => {
                const chatChannel = chat.channel || chat.hash
                if (chatChannel != latestMessage.channel)
                    return chat

                const message = { ...latestMessage.message }
                let messages = Array.isArray(chat.messages) ? [...chat.messages] : []
                const messageIndex = message.id !== undefined && message.id !== null
                    ? messages.findIndex(each => each.id === message.id)
                    : -1

                if (messageIndex >= 0)
                    messages[messageIndex] = { ...messages[messageIndex], ...message }
                else
                    messages.push(message)

                changed = true

                return {
                    ...chat,
                    messages: messages,
                    last_message: message,
                   last_user_message: message.user_id === 0 ? message : chat.last_user_message,
                    last_user_msg_time: message.user_id === 0 ? message.time : chat.last_user_msg_time,
                    unread_messages: props.activeChat?.uniqueid === chat.uniqueid ? 0 : chat.unread_messages,
                }
            })

            newState[stateKey] = nextChats
        })

        if (changed)
            setAllChats(prevState => ({ ...prevState, ...newState }))
    }

    useEffect(() => {
        updateChatMessagePreview(props.latestMessage)
    }, [props.latestMessage])

    const setReadMessages = (messages) => {
        if (messages.length === 0)
            return;

        // Setting unreadMessages is_read
        const unreadMessagesIds = messages.map(m => m.id).filter(id => id);

        if (unreadMessagesIds.length === 0)
            return;

        api.post('/api/LHC/messages/set_read/', {
            messages: unreadMessagesIds
        }).then((res) => {
            if (res.status === 200)
                messages.map(each => { 'is_read' in each ? each.is_read = true : null })
            reloadState()
            return;
            throw res;
        }).catch((err) => {
            console.error(err);
        });
    }

    const handleMarkUnread = async (chat, where) => {
        const endpoint = chat.is_marked_unread ? 'unmark_unread' : 'mark_unread'
        await api.post(`api/enterprises/${props.enterpriseId}/calls/chat/${endpoint}/`, { channel: chat.channel })
        const stateKey = `${where}State`
        const target = allChats[stateKey].find(c => c.channel === chat.channel)
        if (target)
            target.is_marked_unread = !chat.is_marked_unread
        switch (where) {
            case 'queue':  setQueueAdded(p => !p);  break
            case 'onchat': setOnchatAdded(p => !p); break
            default: break
        }
    }

    const handlePinToggle = async (chat, where) => {
        const endpoint = chat.is_pinned ? 'unpin' : 'pin'
        await api.post(`api/enterprises/${props.enterpriseId}/calls/chat/${endpoint}/`, { channel: chat.channel })
        allChats[`${where}State`] = []
        allChats[`${where}Amount`] = 0
        await getData(where)
        switch (where) {
            case 'queue':    setQueueAdded(p => !p);    break
            case 'onchat':   setOnchatAdded(p => !p);   break
            default: break
        }
    }

    const reloadQueue = async (queue) => {
        if (timeout) return

        allChats[`${queue}State`] = []
        queue === 'queue' ? setQueueAdded(p => !p) : setOnchatAdded(p => !p)

        setTimeout(() => { timeout = false }, 1000)
        timeout = true
    }

    const getDataWithJustMe = (...args) => {
        return getData(...args);
    };

    const getDataApiWithJustMe = async () => {
        const newchat = await getData('notification', 0);
    }

    useEffect(() => {
        getDataApiWithJustMe()
    }, [justMe])

    const removeNotificationParams = () => {
        const params = new URLSearchParams(location.search)

        params.delete("uniqueId")
        params.delete("list")

        const search = params.toString()

        history.replace({
            pathname: location.pathname,
            search: search ? `?${search}` : "",
        })
    }

    const findChatFromUrl = async (uniqueId, list) => {
        if (!uniqueId || !["queue", "onchat"].includes(list))
            return

        // Select the appropriate chat list/tab first
        if (list === "queue")
            setActiveTab(null, 0)
        else if (list === "onchat")
            setActiveTab(null, 1)

        // First search chats already loaded
        let currentChats = allChats[`${list}State`] || []

        let chat = currentChats.find(
            chat => String(chat.uniqueid) === String(uniqueId)
        )

        if (chat) {
            itemClicked(chat)
            removeNotificationParams()
            return
        }

        // TODO: improve this to request chat from the backend and show

        removeNotificationParams()
        console.warn(
            `Chat ${uniqueId} was not found in the first set of ${list}`
        )
    }

    useEffect(() => {
        const params = new URLSearchParams(location.search)

        const uniqueId = params.get("uniqueId")
        const list = params.get("list")

        // Nothing to do if this isn't a notification navigation
        if (!uniqueId)
            return

        if (!["queue", "onchat"].includes(list))
            return

        findChatFromUrl(uniqueId, list)
    }, [allChats, location.search])

    return (
        <>
            <Loading loading={outLoading} />
            <Box id="conversationList-box-1">
                <Box id="conversationList-box-2">
                    <Box id="conversationList-box-3">
                        <Tabs
                            value={props.activeTab}
                            onChange={setActiveTab}
                            className={`tabs-conversation-list`}
                        >
                            <Tab onClick={() => setNewQueue(0)}
                                label={
                                    <SwitchHover
                                        active={props.activeTab == 0}
                                        normal={
                                            <Tooltip title="Fila" placement="bottom" disableInteractive>
                                                <Badge className='lower-badge' color="success" variant="dot" invisible={newQueue === 0}>
                                                    <QueueIcon />
                                                </Badge>
                                            </Tooltip>
                                        } hovering={
                                            <Tooltip title="Recarregar" placement="bottom" disableInteractive>
                                                <Badge className='lower-badge' onClick={() => reloadQueue('queue')} color="success" variant="dot" invisible={newQueue === 0}>
                                                    <RefreshIcon />
                                                </Badge>
                                            </Tooltip>
                                        } />

                                }
                                className="tab badge-unreadMessages"
                            />
                            <Tab
                                label={
                                    <SwitchHover
                                        active={props.activeTab == 1}
                                        normal={
                                            <Tooltip title="Atendimento" placement="bottom" disableInteractive>
                                                <Badge className='lower-badge' color="success" variant="dot" invisible={unreadMessages === 0}>
                                                    <OngoingIcon />
                                                </Badge>
                                            </Tooltip>
                                        }
                                        hovering={
                                            <Tooltip title="Recarregar" placement="bottom" disableInteractive>
                                                <Badge className='lower-badge' onClick={() => reloadQueue('onchat')} color="success" variant="dot" invisible={unreadMessages === 0}>
                                                    <RefreshIcon />
                                                </Badge>
                                            </Tooltip>
                                        } />
                                }
                                className="tab badge-unreadMessages"
                            />
                            <Tab
                                label={
                                    <Tooltip title="Pendente" placement="bottom" disableInteractive>
                                        <ReactivationIcon />
                                    </Tooltip>
                                }
                                className="tab"
                            />
                            <Tab
                                label={
                                    <Tooltip title="Finalizado" placement="bottom" disableInteractive>
                                        <FinishedIcon />
                                    </Tooltip>
                                }
                                className="tab"
                            />
                        </Tabs>
                    </Box>
                    {props.activeTab !== 3 &&
                        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                            <Box sx={{ flex: 1 }}>
                                <ServiceFilterComponent
                                    key='filter-component'
                                    filterSettings={filterSettings}
                                    activeTab={props.activeTab}
                                    mode={2}
                                    setFilterSettings={setFilterSettings}
                                    reloadState={reloadState}
                                    setHeartbeat={setHeartbeat}
                                    sortComponent={
                                        <SortComponent
                                            orderBy={orderBy}
                                            updateData={updateData}
                                            color="darkGray"
                                        />
                                    }
                                    hideSort={[3, 2, 1].includes(props.activeTab)}
                                    tooglejustme={
                                        <ToogleJustMe
                                            updatejustme={updatejustme}
                                            color="darkGray"
                                        />
                                    }
                                    showjustme={[2].includes(props.activeTab)}
                                    allGroups={props.allGroups}
                                    onClickSettings={(event) => setSettingsAnchorEl(settingsAnchorEl ? null : event.currentTarget)}
                                />
                            </Box>
                            {/*<Tooltip title="Configurações" placement="bottom">
                                <IconButton 
                                    size="small" 
                                    onClick={(event) => setSettingsAnchorEl(settingsAnchorEl ? null : event.currentTarget)}
                                >
                                    <SettingsIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>*/}
                        </Box>
                    }
                    <Popper className="manage-calls-settings" open={Boolean(settingsAnchorEl)} anchorEl={settingsAnchorEl} placement="bottom">
                        <ClickAwayListener onClickAway={() => setSettingsAnchorEl(null)}>
                            <Paper>
                                <Typography>
                                    Alerta Visual
                                </Typography>
                                <TextField
                                    label="Minutos"
                                    type="number"
                                    size="small"
                                    fullWidth
                                    value={progressBarMax}
                                    onChange={(e) => setProgressBarMax(parseInt(e.target.value))}
                                />
                            </Paper>
                        </ClickAwayListener>
                    </Popper>
                    {props.activeTab === 3 &&
                        <FinishedFilter
                            classificationFilter={classificationFilter}
                            setClassificationFilter={setClassificationFilter}
                            selectedChats={selectedChats}
                            setSelectedChats={setSelectedChats}
                        />
                    }
                    <TabPanel value={props.activeTab} index={0}>
                        <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
                            <Box sx={{ flex: 1 }}>
                                <QueueContainer
                                    queueName={'Fila'}
                                    queueWhere={'queue'}
                                    queueAmount={allChats.queueAmount}
                                    queueRow={allChats.queueState}
                                    onClickItem={itemClicked}
                                    fetching={loading}
                                    limit={limit}
                                    callData={getData}
                                    queueAdded={queueAdded}
                                    listMode={true}
                                    setReadMessages={setReadMessages}
                                    activeChat={props.activeChat}
                                    labels={props.labels}
                                    connectEmailChat={props.connectEmailChat}
                                    progressBarMax={progressBarMax}
                                    onPinToggle={handlePinToggle}
                                    onMarkUnread={handleMarkUnread}
                                />
                            </Box>
                        </Box>
                    </TabPanel>
                    <TabPanel value={props.activeTab} index={1}>
                        <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
                            <Box sx={{ flex: 1 }}>
                                <QueueContainer
                                    queueName={"Atendimentos"}
                                    queueWhere={"onchat"}
                                    queueAmount={allChats.onchatAmount}
                                    queueRow={allChats.onchatState}
                                    onClickItem={itemClicked}
                                    fetching={loading}
                                    limit={limit}
                                    callData={getData}
                                    queueAdded={onchatAdded}
                                    listMode={true}
                                    setReadMessages={setReadMessages}
                                    activeChat={props.activeChat}
                                    labels={props.labels}
                                    progressBarMax={progressBarMax}
                                    onPinToggle={handlePinToggle}
                                    onMarkUnread={handleMarkUnread}
                                />
                            </Box>
                        </Box>
                    </TabPanel>
                    <TabPanel value={props.activeTab} index={2}>
                        <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
                            <Tabs
                                value={props.activeSubTab}
                                className={`tabs-conversation-list`}
                                onChange={(e, tab) => { props.setActiveSubTab(tab) }}
                            >
                                <Tab
                                    sx={{ flex: 1 }}
                                    className="tab"
                                    label={
                                        <Tooltip title="Reativações" placement="bottom" disableInteractive>
                                            <span>Reativações</span>
                                        </Tooltip>
                                    }
                                />
                                <Tab
                                    sx={{ flex: 1 }}
                                    className="tab"
                                    label={
                                        <Tooltip title="Notificações" placement="bottom" disableInteractive>
                                            <span>Notificações</span>
                                        </Tooltip>
                                    }
                                />
                            </Tabs>
                            <TabPanel value={props.activeSubTab} index={0}>
                                <QueueContainer
                                    queueName={'Pendentes'}
                                    queueWhere={'reactivated'}
                                    queueAmount={allChats.reactivatedAmount}
                                    queueRow={allChats.reactivatedState}
                                    onClickItem={itemClicked}
                                    fetching={loading}
                                    limit={limit}
                                    callData={getData}
                                    queueAdded={reactivatedAdded}
                                    listMode={true}
                                    setReadMessages={setReadMessages}
                                    activeChat={props.activeChat}
                                    labels={props.labels}
                                    progressBarMax={progressBarMax}
                                />
                            </TabPanel>
                            {props.activeSubTab == 1 ?
                                <TabPanel value={props.activeSubTab} index={1}>
                                    <QueueContainer
                                        queueName={'Notificações'}
                                        queueWhere={'notification'}
                                        queueAmount={allChats.notificationAmount}
                                        queueRow={allChats.notificationState}
                                        onClickItem={itemClicked}
                                        fetching={loading}
                                        limit={limit}
                                        callData={getDataWithJustMe}
                                        regenerate={() => {
                                            allChats['notificationState'] = []
                                            allChats['notificationAmount'] = 0
                                        }
                                        }
                                        queueAdded={notificationAdded}
                                        listMode={true}
                                        setReadMessages={setReadMessages}
                                        activeChat={props.activeChat}
                                        AsNotification={false}
                                        labels={props.labels}
                                        progressBarMax={progressBarMax}
                                    />
                                </TabPanel>
                                : null}
                        </Box>
                    </TabPanel>
                    <TabPanel value={props.activeTab} index={3}>
                        <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
                            {!finished_infinite_scroll ? <Box sx={{ flex: 1 }}>
                                <QueueContainer
                                    queueName={'Finalizados'}
                                    queueWhere={'finished'}
                                    queueAmount={allChats.finishedAmount}
                                    queueRow={allChats.finishedState}
                                    onClickItem={itemClicked}
                                    fetching={loading}
                                    limit={limit}
                                    callData={getData}
                                    queueAdded={finishedAdded}
                                    listMode={true}
                                    setReadMessages={setReadMessages}
                                    activeChat={props.activeChat}
                                    labels={props.labels}
                                    disabled={filterSettings}
                                    progressBarMax={progressBarMax}
                                />
                            </Box>
                                :
                                <FinishedQueueContainer
                                    key={'finished-queue-container'}
                                    onClickItem={itemClicked}
                                    onCtrlClickItem={itemCtrlClicked}
                                    isManageCalls={false}
                                    activeChat={props.activeChat}
                                    queueAmount={allChats.finishedAmount}
                                    filterSettings={filterSettings}
                                    setFilterSettings={setFilterSettings}
                                    disabled={filterSettings}
                                    classificationFilter={classificationFilter}
                                    selectedChats={selectedChats}
                                />
                            }
                        </Box>
                    </TabPanel>
                </Box>
            </Box>
        </>
    )
}


export default NewConversationList
